import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchAuditLogsApi } from '../services/adminAuditLogs'

const getUserId = (state) => {
  const id = state.auth?.userData?.id
  if (id) return id

  try {
    const token = localStorage.getItem('access_token')
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]))
      return payload.sub || payload.id || payload.user_id || null
    }
  } catch (e) {}

  return null
}

export const fetchAuditLogs = createAsyncThunk(
  'adminAuditLogs/fetchAuditLogs',
  async (_, thunkAPI) => {
    try {
      const state = thunkAPI.getState()
      const { filters, offset } = state.adminAuditLogs
      const userId = getUserId(state)

      if (!userId) {
        return thunkAPI.rejectWithValue('SESSION_EXPIRED')
      }

      return await fetchAuditLogsApi({ filters, offset, userId })
    } catch (err) {
      return thunkAPI.rejectWithValue(err.type || err.message || 'Error desconocido')
    }
  }
)

const initialState = {
  data: [],
  total: 0,
  limit: 50,
  offset: 0,
  loading: false,
  error: null,
  filters: {
    type: '',
    event_type: '',
    user_id: '',
    from: '',
    to: '',
    order: 'desc'
  }
}

const adminAuditLogsSlice = createSlice({
  name: 'adminAuditLogs',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload }
    },
    resetFilters: (state) => {
      state.filters = { ...initialState.filters }
      state.offset = 0
    },
    setOffset: (state, action) => {
      state.offset = action.payload
    },
    clearError: (state) => {
      state.error = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuditLogs.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchAuditLogs.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.data
        state.total = action.payload.total
        state.offset = action.payload.offset
      })
      .addCase(fetchAuditLogs.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || 'Error desconocido'
        state.data = []
      })
  }
})

export const { setFilters, resetFilters, setOffset, clearError } = adminAuditLogsSlice.actions

export const selectAuditLogs = (state) => state.adminAuditLogs.data
export const selectAuditLogsTotal = (state) => state.adminAuditLogs.total
export const selectAuditLogsLimit = (state) => state.adminAuditLogs.limit
export const selectAuditLogsOffset = (state) => state.adminAuditLogs.offset
export const selectAuditLogsLoading = (state) => state.adminAuditLogs.loading
export const selectAuditLogsError = (state) => state.adminAuditLogs.error
export const selectAuditLogsFilters = (state) => state.adminAuditLogs.filters

export default adminAuditLogsSlice.reducer
